import { useAccountSwitcherContext } from '../components/AccountSwitcherProvider';

/**
 * Hook to access account switcher methods
 * Returns methods for switching accounts, adding accounts, managing account, updating avatar, and logging out
 */
export function useAccountSwitcher() {
  const {
    switchAccount,
    addAccount,
    manageAccount,
    updateAvatar,
    logoutAccount,
    logoutAll,
    refresh,
    client,
    sendMessage,
  } = useAccountSwitcherContext();

  return {
    switchAccount,
    addAccount,
    manageAccount,
    updateAvatar,
    logoutAccount,
    logoutAll,
    refresh,
    // The live PostMessage client + sender, needed by the cross-product handoff
    // (HandoffLanding → multiAccountAutoAdd). `client` is null until the
    // provider's mount effect initializes it.
    client,
    sendMessage,
  };
}
